import React, { useContext, useState, useEffect, useRef, useMemo } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { Button, Row, Col } from 'react-bootstrap';
import { AddressForm } from '../../components/Vendor/ET/CustomerAddressForm';
import { ContractContext } from '../../components/contexts/ContractContext';
import SimpleReactValidator from 'simple-react-validator';
import { Label, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import styles from './Reimbursement.module.css';
import useReimbursementStore from './useReimbursementStore';
import { getColumns } from './ReimbursementColumns';
import { AIGInverseAlert } from './FormFormatters/InverseAlert';
import { verifyAddress, VerificationResponseCodes } from '../../components/api/addressverification';
import SuggestedAddress from '../../components/modals/SuggestedAddress';
import InvalidAddress from '../../components/modals/InvalidAddress';
import { useHistory, useRouteMatch } from 'react-router-dom';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import { currencyInputFormatter } from './FormFormatters/CurrencyInputFormatter';

const ReimbursementForm = () => {
    const router = useHistory();
    const context = useContext(ContractContext);
    const contract = context.data?.contract;
    const claimInfo = router.location.state;
    const [states, setStates] = useState([]);
    const [state, setState] = useState([]);
    const [validationFired, setValidationFired] = useState(false);
    const [claimDetails, setClaimDetails] = useState(null);
    const [contractDetails, setContractDetails] = useState(null);
    const [foodLossDetails, setFoodLossDetails] = useState(null);
    const [validationTick, setValidationTick] = useState(0);
    const forceValidationRerender = () => setValidationTick((t) => t + 1);

    const [affirmed, setAffirmed] = useState('');
    const tableData = useReimbursementStore((state) => state.tableData);
    const addRow = useReimbursementStore((state) => state.addRow);
    const [, forceUpdate] = useState();

    const urlPath = useRouteMatch('/RequestReimbursementForm/:clientId/:token');
    const token = urlPath?.params?.token;
    const clientIdFromUrl = urlPath?.params?.clientId;
    const clientId = clientIdFromUrl || context?.data?.clientId || contractDetails?.clientId;
    const claimId = claimInfo?.claimData || claimDetails?.claimNumber;
    const eventId = claimInfo?.eventId;
    const contractPartyDetails = contractDetails ?? contract;
    const [formData, setFormData] = useState({});
    const [showSuggestedAddressValidationModal, setSuggestedAddressModal] = useState(false);
    const [showInvalidAddressModal, setInvalidAddressModal] = useState(false);
    const [verifiedAddress, setVerifiedAddress] = useState(null);
    const [addressToVerify, setAddressToVerfy] = useState(null);
    const [bypassServiceMelissaValidation, setBypassServiceMelissaValidation] = useState(false);
    const [party, setParty] = useState(null);

    const getInitialParty = () => {
        const handshakeParty = context?.data?.viaClientHandshake?.party;
        const normalParty = context?.data?.party;
        const contractParty = contractDetails?.party;
        if (handshakeParty && Object.keys(handshakeParty ?? {}).length > 0) return handshakeParty;
        if (normalParty && Object.keys(normalParty ?? {}).length > 0) return normalParty;
        return contractParty ?? null;
    };
    useEffect(() => {
        if (party) return;
        const initialParty = getInitialParty();
        if (initialParty) setParty(initialParty);
    }, [party, context, contractDetails]);

    useEffect(() => {
        if (party) {
            setFormData({
                name: party?.partyName === null ? party?.firstName.concat(' ', party?.lastName) : party?.partyName,
                firstname: party?.firstName,
                lastName: party?.lastName,
                email: party?.partyEmailModel?.[0]?.address,
                alternatePhone: party?.partyPhoneModel?.find(({ phoneTypeId }) => phoneTypeId === 1)?.number ?? '',
                mobilePhone: party?.partyPhoneModel?.find(({ phoneTypeId }) => phoneTypeId === 2)?.number ?? '', ///Primary phone number
                address1: party?.partyAddressModel?.find(({ addressTypeId }) => addressTypeId === 3)?.address1 ?? '',
                address2: party?.partyAddressModel?.find(({ addressTypeId }) => addressTypeId === 3)?.address2 ?? '',
                city: party?.partyAddressModel?.find(({ addressTypeId }) => addressTypeId === 3)?.city ?? '',
                state: party?.partyAddressModel?.find(({ addressTypeId }) => addressTypeId === 3)?.state ?? '',
                stateId: party?.partyAddressModel?.find(({ addressTypeId }) => addressTypeId === 3)?.stateId ?? '',
                zip: party?.partyAddressModel?.find(({ addressTypeId }) => addressTypeId === 3)?.zip ?? '',
                billingAddress: {
                    address1: party?.billingAddress?.address1 ?? '',
                    address2: party?.billingAddress?.address2 ?? '',
                    city: party?.billingAddress?.city ?? '',
                    state: party?.billingAddress?.state ?? '',
                    stateId: party?.billingAddress?.stateId ?? '',
                    zip: party?.billingAddress?.zip ?? ''
                },
                serviceAddress: {
                    address1: party?.serviceAddress?.address1 ?? '',
                    address2: party?.serviceAddress?.address2 ?? '',
                    city: party?.serviceAddress?.city ?? '',
                    state: party?.serviceAddress?.state ?? '',
                    stateId: party?.serviceAddress?.stateId ?? '',
                    zip: party?.serviceAddress?.zip ?? ''
                },
                mailingAddress: {
                    address1: party?.shippingAddress?.address1 ?? '',
                    address2: party?.shippingAddress?.address2 ?? '',
                    city: party?.shippingAddress?.city ?? '',
                    state: party?.shippingAddress?.state ?? '',
                    stateId: party?.shippingAddress?.stateId ?? '',
                    zip: party?.shippingAddress?.zip ?? ''
                }
            });
        }
    }, [party]);

    const verifyToken = () => {
        fetch(`/vendor/Reimbursement/verifyReimbursementToken/${token}/${clientId}`, {
            method: 'get'
        }).then((res) => {
            if (res.ok) {
                res.json().then((result) => {
                    setClaimDetails(result.claimModel);
                    setContractDetails(result.contractModel);
                    const partyDetails =
                        Object.keys(context?.data?.viaClientHandshake ?? {}).length > 0
                            ? context?.data?.viaClientHandshake?.party
                            : Object.keys(context?.data?.party ?? {}).length > 0
                              ? context?.data?.party
                              : (result?.contractModel?.party ?? null);
                    setParty(partyDetails);

                    const defaultfoodLossCoverageClaimDetail = {
                        claimId: result.claimModel?.claimId,
                        isFoodLossClaim: false,
                        isFoodLossCoverageEligible: false,
                        foodLossLolMax: 0,
                        foodLossLolUsed: 0,
                        foodLossCoverageRemaining: 0
                    };
                    const coverageClaimDetail = result.claimModel?.coverageClaimDetails?.find(
                        (detail) => detail.coverageId === 3
                    );

                    const foodLossCoverageClaimDetail = coverageClaimDetail
                        ? {
                              claimId: coverageClaimDetail.claimId,
                              isFoodLossClaim: true,
                              isFoodLossCoverageEligible: coverageClaimDetail.isCoverageEligible,
                              foodLossLolMax: coverageClaimDetail.lolMax,
                              foodLossLolUsed: coverageClaimDetail.lolUsed,
                              foodLossCoverageRemaining: coverageClaimDetail.coverageRemaining
                          }
                        : defaultfoodLossCoverageClaimDetail;

                    setFoodLossDetails(foodLossCoverageClaimDetail);
                    router?.push({
                        pathname: '/reimbursementform'
                    });
                });
            }
        });
    };
    //api/claim/GetReimbursementDetails/3278155/4117851/homekick
    const verifyReimbursementDetails = () => {
        fetch(`api/claim/GetReimbursementDetails/${claimId}/${clientId}`, {
            method: 'get'
        }).then((res) => {
            if (res.ok) {
                res.json().then((result) => {
                    console.log('result', result);
                    setClaimDetails(result.claimModel);
                    setContractDetails(result.contractModel);
                    const partyDetails = result?.contractModel?.party ?? null;
                    setParty(partyDetails);

                    const defaultfoodLossCoverageClaimDetail = {
                        claimId: result.claimModel?.claimId,
                        isFoodLossClaim: false,
                        isFoodLossCoverageEligible: false,
                        foodLossLolMax: 0,
                        foodLossLolUsed: 0,
                        foodLossCoverageRemaining: 0
                    };
                    const coverageClaimDetail = result.claimModel?.coverageClaimDetails?.find(
                        (detail) => detail.coverageId === 3
                    );

                    const foodLossCoverageClaimDetail = coverageClaimDetail
                        ? {
                              claimId: coverageClaimDetail.claimId,
                              isFoodLossClaim: true,
                              isFoodLossCoverageEligible: coverageClaimDetail.isCoverageEligible,
                              foodLossLolMax: coverageClaimDetail.lolMax,
                              foodLossLolUsed: coverageClaimDetail.lolUsed,
                              foodLossCoverageRemaining: coverageClaimDetail.coverageRemaining
                          }
                        : defaultfoodLossCoverageClaimDetail;

                    setFoodLossDetails(foodLossCoverageClaimDetail);
                    router?.push({
                        pathname: '/reimbursementform'
                    });
                });
            }
        });
    };

    useEffect(() => {
        if (token) {
            verifyToken();
        }
    }, [token]);

    useEffect(() => {
        verifyReimbursementDetails();
    }, []);

    useEffect(() => {
        fetch('api/party/states/'.concat(clientId))
            .then((res) => res.json())
            .then((data) => {
                const result = [];
                data.map((s) => {
                    result.push({
                        data: s.stateId,
                        display: s.name
                    });
                    setStates({ state: result });
                });
            });
    }, []);

    const validator = useRef(
        new SimpleReactValidator({
            element: (message) => (
                <div
                    className='errorMsg'
                    aria-live='polite'
                >
                    {message.charAt(0).toUpperCase() + message.slice(1)}
                </div>
            ),

            validators: {
                valid_affirm: {
                    message: 'Please affirm the information provided is true and accurate.',
                    rule: (val, params, validator) => {
                        if (val === '') {
                            return false;
                        }
                        return true;
                    },
                    required: true
                }
            }
        })
    );

    const handleContactInfo = async () => {
        setValidationFired(true);
        const activePriceFields = new Set((tableData || []).map((row) => `price_${row.id}`));
        Object.keys(validator.current?.fields || {}).forEach(
            (key) => key.startsWith('price_') && !activePriceFields.has(key) && delete validator.current.fields[key]
        );
        const hasInvalidPrice = (tableData || []).some((row) => Number(row.price) === 0);
        const isFormValid = validator.current.allValid();

        if (isFormValid && !hasInvalidPrice && !(isTotalError || isTotalTokenError)) {
            const addressObj = {
                address1: formData?.address1 ?? '',
                address2: formData?.address2 ?? '',
                city: formData?.city ?? '',
                state: formData?.state ?? '',
                stateId: formData.stateId ?? '',
                zip: formData?.zip ?? '',
                country: formData?.state?.countryModel?.Iso2 ?? 'US'
            };
            setAddressToVerfy(addressObj);
            if (!bypassServiceMelissaValidation) {
                await verifyAddress(addressObj, contractPartyDetails?.clientId, onAddressVerified);
            }
            const payload = {
                ClaimId: router.location?.state?.claimData || claimDetails?.claimId,
                InvoiceAmount: totalAmount,
                AuthorizationDisplayModel: tableData.map((item) => ({
                    Qty: item.qty ?? 1,
                    Description: item.description,
                    UnitPrice: item.price,
                    AuthorizedAmount: item.qty * item.price
                }))
            };
            try {
                const response = await fetch(
                    `/api/claim/CreateFoodLossReimbursementEvent/${contractPartyDetails.clientId}`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(payload)
                    }
                );

                if (!response.ok) {
                    throw new Error('Reimbursement API throws an error');
                }
                const result = await response.json();
                //Push to confirmation on success
                router.push({
                    pathname: '/reimbursementconfirmation',
                    state: {
                        reimbursementData: formData,
                        clientId: clientId,
                        claimId: claimDetails?.claimId || claimInfo.claimData
                    }
                });
            } catch (error) {
                console.error('Error submitting reimbursement:', error);
                return;
            }
        } else {
            tableData.forEach((r) => {
                validator.current.showMessageFor(`price_${r.id}`);
            });
            validator.current.showMessages();
            forceValidationRerender();
            return;
        }
    };

    const onAddressVerified = (result) => {
        if (result.code === VerificationResponseCodes.addressVerified) {
            setVerifiedAddress(result.returnedAddress);
            setSuggestedAddressModal(true);
        } else if (result.code === VerificationResponseCodes.addressChanged) {
            setVerifiedAddress(result.returnedAddress);
            setSuggestedAddressModal(true);
        } else {
            setInvalidAddressModal(true);
        }
    };
    const onContinueSaveAction = (selectedAddress) => {
        let partyAddress = party?.partyAddressModel;
        partyAddress.find(({ addressTypeId }) => addressTypeId === 3).address1 = formData.address1;
        partyAddress.find(({ addressTypeId }) => addressTypeId === 3).address2 = formData.address2;
        partyAddress.find(({ addressTypeId }) => addressTypeId === 3).city = formData.city;
        partyAddress.find(({ addressTypeId }) => addressTypeId === 3).state = formData.state;
        partyAddress.find(({ addressTypeId }) => addressTypeId === 3).stateId = formData.stateId;
        partyAddress.find(({ addressTypeId }) => addressTypeId === 3).zip = formData.zip;

        fetch('api/party/'.concat(party.partyId, '/').concat(clientId), {
            method: 'put',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                partyId: party.partyId,
                firstName: party.firstName,
                lastName: party.lastName,
                partyName: party.firstName + ' ' + party.lastName,
                partyAddressModel: partyAddress,
                city: formData.city,
                zipcode: formData.zip,
                state: formData.state
            })
        })
            .then((res) => {
                if (res.status === 204) {
                    console.log('no content');
                    return null;
                }
                if (res.ok) {
                    return res?.json();
                }
            })
            .then((data) => {
                var editedData = JSON.parse(sessionStorage.getItem('appState'));
                editedData.party = data;
                sessionStorage.setItem('appState', JSON.stringify(editedData));
                router.push({
                    pathname: '/reimbursementconfirmation',
                    state: {
                        reimbursementData: formData,
                        clientId: clientId,
                        claimId: claimDetails?.claimId || claimInfo.claimData
                    }
                });
            });
    };

    const onCloseAddressModal = () => {
        setSuggestedAddressModal(false);
        setInvalidAddressModal(false);
    };

    const affirmationChange = () => {
        if (affirmed === '') {
            setAffirmed('affirmed');
        } else {
            setAffirmed('');
        }
    };

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleStateDropDown = (e) => {
        const selectedState = Array.isArray(states.state) ? states.state.find(({ data }) => data === e).display : 0;
        setFormData({
            ...formData,
            state: selectedState,
            stateId: e
        });
    };

    const totalAmount = tableData
        ?.reduce((sum, row) => {
            const qty = parseFloat(row.qty);
            const price = parseFloat(row.price);
            return sum + (isNaN(qty) || isNaN(price) ? 0 : qty * price);
        }, 0)
        .toFixed(2);

    const isTotalError = Number(totalAmount) > claimInfo?.foodLossLolMax;
    const isTotalTokenError = Number(totalAmount) > foodLossDetails?.foodLossLolMax;

    const partyName = contractPartyDetails?.party?.firstName.concat(' ', contractPartyDetails?.party?.lastName);
    const columns = useMemo(
        () =>
            getColumns({
                validator: validator?.current,
                validationTick,
                forceValidationRenderer: forceValidationRerender,
                validationFired
            }),
        [validationTick, validationFired, forceValidationRerender]
    );

    const hasInvalidPrice = validationFired && (tableData || []).some((row) => Number(row.price) === 0);

    return (
        <>
            <div className='container mt-4'>
                <h3 className={classNames(styles.btmLine, 'mb-3')}>Food Spoilage Reimbursement Claim</h3>
                <div>
                    <p className='mb-0'>
                        To request reimbursement for food spoilage, please complete the following form:
                    </p>
                    <ul className={classNames('mt-0', styles.listPadding)}>
                        <li className='mt-0'>
                            Include only perishable food items that spoiled and cannot be consumed.
                        </li>
                        <li>In the price per unit column, add the fair market price based on the quantity listed.</li>
                    </ul>
                    <p>
                        Please Note: Not all food items are covered by the contract, review the &nbsp;
                        <Link
                            to='/coveragedocs'
                            target='_blank'
                            aria-label='Terms and conditions opens a new details window'
                        >
                            terms and conditions
                        </Link>
                        &nbsp; for full coverage details.
                    </p>
                </div>
                <p className='mb-4'>
                    For concerns regarding your claim, contact{' '}
                    <a
                        href='tel:866-523-8649'
                        aria-label='Click to Call 866-523-8649'
                        className='callLink'
                    >
                        (866) 523-8649
                    </a>{' '}
                    and reference your claim number.
                </p>

                <label className='form-label font-weight-bold'>Claim Details</label>
                <p className='mb-1'>Name: {partyName || contract?.party?.lastName}</p>
                <p className='mb-1'>Claim Number: {claimInfo?.claimData || claimDetails?.claimNumber}</p>
                <p className='mb-1'>Plan Number: {contract?.contractNumber || contractDetails?.contractNumber}</p>
                <p className='mb-0'>
                    Failure Date:{' '}
                    {claimInfo?.claimSetupData || moment(claimDetails?.claimSetupDate).format('MM/DD/YYYY')}
                </p>

                <div className='position-relative'>
                    <BootstrapTable
                        key={validationTick}
                        keyField='id'
                        columns={columns}
                        data={tableData}
                        bordered={true}
                        wrapperClasses={classNames('table-responsive', styles.cleanTable, 'mb-4', 'mt-4')}
                    />
                </div>
                <div className={isTotalError || isTotalTokenError ? styles.noPaddingFooter : styles.cleanTableFooter}>
                    {(isTotalError || isTotalTokenError) && (
                        <AIGInverseAlert
                            color='warning'
                            reason={`Please Note: Max food spoilage reimbursement total will not exceed $${foodLossDetails?.foodLossCoverageRemaining || claimInfo?.foodLossLolMax}. Review the terms and conditions for full coverage details.`}
                        />
                    )}
                    <div className={styles.newItem}>
                        <button
                            className='btn btn-secondary'
                            onClick={addRow}
                        >
                            + Add New Line
                        </button>
                        <div>
                            Total Amount:{' '}
                            <span
                                className={`${styles.amount} ${isTotalError || isTotalTokenError ? styles.amountError : ''}`}
                            >
                                <NumberFormat
                                    value={totalAmount}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                />
                            </span>
                        </div>
                    </div>
                </div>

                <h3 className='mt-4'>Verify Your Mailing Address</h3>
                <p>If your request is approved, where would you like your reimbursement check sent?</p>

                <Col
                    lg='4'
                    className='p-0 mb-3'
                >
                    <AddressForm
                        address={{
                            address1: formData.address1,
                            address2: formData.address2,
                            city: formData.city,
                            zip: formData.zip,
                            state: formData.state,
                            stateId: formData.stateId
                        }}
                        states={states.state}
                        handleInputChange={handleInputChange}
                        handleStateDropDown={handleStateDropDown}
                        onChangedValue={handleStateDropDown}
                        validator={validator.current}
                        validationFired={validationFired}
                        clientId={contract.clientId}
                    />
                </Col>
                <Row>
                    <Col
                        id='affirm'
                        className='formBlock'
                    >
                        <div className={`checkbox scriptBox ${!affirmed && validationFired && 'form-error'}`}>
                            <Input
                                className='mr-2'
                                type='checkbox'
                                id='affirmStatement'
                                name='affirmationStatement'
                                onChange={affirmationChange}
                                tabIndex='0'
                                checked={affirmed === 'affirmed'}
                                aria-required='true'
                                aria-label='To complete claim'
                                className={'form-control'}
                            />
                            <Label
                                for='affirmStatement'
                                className={`checkboxLabel ${clientId?.toLowerCase()}`}
                            >
                                You affirm that the information you have provided regarding the fair market price of
                                spoiled food is true and accurate. You understand that if you knowingly and
                                intentionally provide false or untrue information regarding your claim, it may be
                                considered fraud.
                            </Label>
                            {validator?.current?.message('affirmationStatement', affirmed, 'valid_affirm')}
                        </div>
                        <button
                            className='btn btn-primary mb-2 mt-2'
                            onClick={handleContactInfo}
                        >
                            Submit
                        </button>
                    </Col>
                </Row>
            </div>
            {showSuggestedAddressValidationModal && (
                <SuggestedAddress
                    showSuggestedAddressValidationModal={showSuggestedAddressValidationModal}
                    enteredAddress={addressToVerify}
                    suggestedAddress={verifiedAddress}
                    onContinueAction={onContinueSaveAction}
                    onEditAddress={onCloseAddressModal}
                />
            )}
            {showInvalidAddressModal && (
                <InvalidAddress
                    showInvalidAddressModal={showInvalidAddressModal}
                    onEditAddress={onCloseAddressModal}
                    onContinueAction={onContinueSaveAction}
                />
            )}
        </>
    );
};
export default ReimbursementForm;
